// Wszystkie treści strony LAKE HOUSE JUNO w jednym miejscu.
// Zdjęcia z prefiksem "customer-assets" to prawdziwe fotografie obiektu.

export const IMAGES = {
  // Hero — nie zmieniamy, zdjęcie już jest naszym prawdziwym ujęciem jacuzzi.
  heroJacuzzi:
    "https://customer-assets.emergentagent.com/job_5d31d595-abeb-4575-a2eb-faebe92be5db/artifacts/g11rra0v_FOTO14.webp",

  // Wszystkie poniższe to nasze własne zdjęcia obiektu (frontend/public/images).
  bedroom: "/images/sypialnia-parter.jpg",
  beachSup: "/images/plaza-sup.jpg",
  kayakSunset: "/images/sup-zachod-slonca.jpg",
  livingRoom: "/images/salon.jpg",
  lakeForest: "/images/jezioro-spokoj.jpg",
  grill: "/images/taras-grill.jpg",

  jacuzziZima: "/images/jacuzzi-zima.jpg",
  jacuzziWieczor: "/images/jacuzzi-wieczor.jpg",
  jacuzziKolorowe: "/images/jacuzzi-kolorowe-swiatla.jpg",
  plazaLezaki: "/images/plaza-lezaki.jpg",
  hamakOgrod: "/images/hamak-ogrod.jpg",
  hamakTaras: "/images/hamak-taras.jpg",
  bocianieGniazdo: "/images/bocianie-gniazdo.jpg",
  sciezkaOgrod: "/images/sciezka-ogrod.jpg",
  tarasNiebieskieOkiennice: "/images/taras-niebieskie-okiennice.jpg",
  fasadaKwiaty: "/images/fasada-kwiaty.jpg",
  domZimaNoc: "/images/dom-zima-noc.jpg",
  choinkaZima: "/images/choinka-zima.jpg",
  tarasPoranek: "/images/taras-poranek.jpg",
  tarasWidokJezioro: "/images/taras-widok-jezioro.jpg",
  kuchniaWidok: "/images/kuchnia-widok.jpg",
  kuchniaWyspa: "/images/kuchnia-wyspa.jpg",
  kuchniaJadalnia: "/images/kuchnia-jadalnia.jpg",
  lazienka1: "/images/lazienka-1.jpg",
  lazienka2: "/images/lazienka-2-prysznic.jpg",
  sypialniaPoddasze1: "/images/sypialnia-poddasze-1.jpg",
  sypialniaMotyle: "/images/sypialnia-motyle.jpg",
  sypialniaGlowna: "/images/sypialnia-glowna.jpg",
  sypialniaPoddasze2: "/images/sypialnia-poddasze-2.jpg",
};

export const NAV_LINKS = [
  { label: "O domu", href: "#o-domu" },
  { label: "Wnętrza", href: "#wnetrza" },
  { label: "Atrakcje", href: "#atrakcje" },
  { label: "Galeria", href: "#galeria" },
  { label: "Cennik", href: "#cennik" },
  { label: "Lokalizacja", href: "#lokalizacja" },
  { label: "Kontakt", href: "#kontakt" },
];

export const CONTACT = {
  phone: "+48 570 292 583",
  phoneHref: "tel:+48570292583",
  facebook: "https://www.facebook.com/dom.mazury.5",
  email: "kontakt@lakehousejuno.pl",
};

export const HERO = {
  eyebrow: "Mazury • Mrągowo • Jezioro Juno",
  title: "Twój azyl nad samym brzegiem jeziora",
  subtitle:
    "Całoroczny dom na wyłączność z prywatnym jacuzzi, tarasem i widokiem na wodę. Miejsce stworzone do prawdziwego relaksu — o każdej porze roku.",
};

export const ABOUT = {
  eyebrow: "Witamy w LAKE HOUSE JUNO",
  title: "Dom, w którym jezioro jest na wyciągnięcie ręki",
  paragraphs: [
    "Zapraszamy do wynajęcia całorocznego domu położonego przy linii brzegowej jeziora Juno w malowniczym Mrągowie. Dostęp do jeziora jest dosłownie na wyciągnięcie ręki, a do dyspozycji naszych Gości są zarezerwowane leżaki na pomoście — gwarancja komfortowego wypoczynku w wyjątkowej scenerii.",
    "Dom komfortowo pomieści do 6 osób i jest w pełni wyposażony, aby zapewnić wygodny i relaksujący pobyt. To idealne miejsce na odpoczynek we dwoje, z rodziną lub przyjaciółmi.",
  ],
  stats: [
    { value: "6", label: "osób" },
    { value: "3", label: "sypialnie" },
    { value: "0 m", label: "do jeziora" },
    { value: "365", label: "dni w roku" },
  ],
};

export const ROOMS = {
  eyebrow: "Wnętrza",
  title: "Przestrzeń urządzona w ciepłym, naturalnym stylu",
  floors: [
    {
      name: "Parter",
      items: [
        "Sypialnia",
        "Przestronny salon z narożnikiem i telewizorem",
        "Łazienka z prysznicem",
        "Jadalnia oraz w pełni wyposażona kuchnia",
        "Piekarnik, płyta indukcyjna, lodówka, zmywarka, ekspres do kawy",
        "Wyjście z kuchni na taras z widokiem na jezioro",
      ],
    },
    {
      name: "Piętro",
      items: [
        "Dwie sypialnie — każda dla 2 osób",
        "Kanapa (bez funkcji spania)",
        "Telewizor",
        "Łazienka z prysznicem",
      ],
    },
  ],
};

export const AMENITIES = [
  {
    icon: "Waves",
    image: IMAGES.jacuzziZima,
    name: "Całoroczne jacuzzi",
    desc: "Prywatne, na tarasie z widokiem na jezioro. Dostępne codziennie 6:00–22:00.",
  },
  {
    icon: "Sailboat",
    image: IMAGES.kayakSunset,
    name: "Sprzęt wodny",
    desc: "2 kajaki, 2 deski SUP i rowerek wodny — dostępne wiosną, latem i jesienią.",
  },
  {
    icon: "LifeBuoy",
    image: IMAGES.plazaLezaki,
    name: "Kamizelki ratunkowe",
    desc: "Bezpieczeństwo na wodzie zapewnione — kamizelki dla całej rodziny w cenie.",
  },
  {
    icon: "Flame",
    image: IMAGES.grill,
    name: "Taras z grillem",
    desc: "Przestronny taras z grillem gazowym — idealny na wspólne wieczory.",
  },
  {
    icon: "TreePalm",
    image: IMAGES.hamakOgrod,
    name: "Hamak brazylijski",
    desc: "Relaks przy jacuzzi w cieniu, z widokiem na taflę wody.",
  },
  {
    icon: "Baby",
    image: IMAGES.bocianieGniazdo,
    name: "Dla najmłodszych",
    desc: "Trampolina i bocianie gniazdo — mnóstwo zabawy dla dzieci.",
  },
  {
    icon: "Gamepad2",
    image: IMAGES.livingRoom,
    name: "Gry i rozrywka",
    desc: "Stół do ping-ponga oraz mini bilard dla całej ekipy.",
  },
  {
    icon: "Car",
    image: IMAGES.sciezkaOgrod,
    name: "Prywatny parking",
    desc: "Miejsce postojowe na posesji — bez martwienia się o samochód.",
  },
];

export const GALLERY = [
  { src: IMAGES.heroJacuzzi, alt: "Jacuzzi na tarasie z widokiem na jezioro" },
  { src: IMAGES.jacuzziWieczor, alt: "Wieczór przy jacuzzi z poczęstunkiem i widokiem na jezioro" },
  { src: IMAGES.hamakOgrod, alt: "Hamak w ogrodzie nad jeziorem" },
  { src: IMAGES.tarasNiebieskieOkiennice, alt: "Taras z niebieskimi okiennicami" },
  { src: IMAGES.fasadaKwiaty, alt: "Fasada domu z kwiatami w oknach" },
  { src: IMAGES.domZimaNoc, alt: "Dom zimą wieczorową porą" },
  { src: IMAGES.choinkaZima, alt: "Ośnieżony ogród przy świątecznych światełkach" },
  { src: IMAGES.tarasPoranek, alt: "Poranny widok na jezioro z tarasu" },
  { src: IMAGES.jacuzziKolorowe, alt: "Jacuzzi w kolorowym podświetleniu o zmierzchu" },
  { src: IMAGES.kuchniaWidok, alt: "Widok na jezioro z kuchni" },
  { src: IMAGES.beachSup, alt: "Deski SUP na plaży nad jeziorem Juno" },
  { src: IMAGES.bedroom, alt: "Przytulna sypialnia na parterze" },
  { src: IMAGES.sypialniaPoddasze1, alt: "Sypialnia na poddaszu" },
  { src: IMAGES.sypialniaPoddasze2, alt: "Druga sypialnia na poddaszu" },
  { src: IMAGES.sypialniaMotyle, alt: "Sypialnia z motylami na ścianie" },
  { src: IMAGES.lazienka2, alt: "Łazienka z kabiną prysznicową" },
  { src: IMAGES.kuchniaJadalnia, alt: "Jadalnia z widokiem na taras" },
];

export const ROOMS_HIGHLIGHTS = [
  { src: IMAGES.sypialniaGlowna, alt: "Sypialnia główna z garderobą", label: "Sypialnia" },
  { src: IMAGES.lazienka1, alt: "Łazienka z drewnianą umywalką", label: "Łazienka" },
  { src: IMAGES.kuchniaWyspa, alt: "Kuchnia z wyspą i barkiem", label: "Kuchnia" },
];

export const PRICING = {
  eyebrow: "Przejrzysty cennik",
  title: "Jedna cena — wszystko w środku",
  price: "1500 zł",
  period: "za dobę",
  note: "Przy 6 osobach to tylko 250 zł / osoba / doba",
  discount: "Mniej niż 6 osób? Rabat 200 zł od każdej doby.",
  deposit:
    "Rezerwacja terminu poprzez zadatek 300 zł za każdą dobę. Pozostała kwota rozliczana w dniu przyjazdu.",
  inclusions: [
    "Całoroczny, komfortowy dom na wyłączność",
    "Prywatne jacuzzi (codziennie 6:00–22:00)",
    "Taras z grillem gazowym i hamakiem",
    "2 kajaki, 2 deski SUP, rowerek wodny",
    "Leżaki na plaży i pomoście",
    "Prąd, woda, ogrzewanie, sprzątanie końcowe",
    "Pralnia i wymiana wody w jacuzzi",
    "Prywatny parking",
  ],
  noHidden: "Bez ukrytych kosztów — wszystko wliczone w cenę!",
};

export const LOCATION = {
  eyebrow: "Lokalizacja",
  title: "W sercu Mazur, blisko wszystkiego",
  description:
    "Do centrum Mrągowa dojedziesz w 5 minut samochodem lub dojdziesz spacerem w 20 minut. Do Mikołajek to zaledwie 25 minut drogi. Idealna baza wypadowa na każdą porę roku.",
  points: [
    { place: "Ratusz w Mrągowie", distance: "2,3 km" },
    { place: "Miasteczko Westernowe Mrongoville", distance: "3,1 km" },
    { place: "Amfiteatr nad jeziorem Czos", distance: "2,8 km" },
    { place: "Wyciągi Góra Czterech Wiatrów", distance: "7 km" },
  ],
};

export const PET_NOTE =
  "Podróżujesz z pupilem? Teren nie jest w pełni ogrodzony. Część Gości zostawia pieska pod opieką bliskich, jednak jeśli nie stanowi to problemu — pupile zwykle są pilnowane na miejscu. Zapraszamy!";

export const CONTACT_SECTION = {
  eyebrow: "Rezerwacja",
  title: "Zarezerwuj swój pobyt nad jeziorem",
  description:
    "Napisz do nas lub zadzwoń — chętnie odpowiemy na wszystkie pytania i pomożemy wybrać najlepszy termin.",
};
